import axios from "axios";
export const state = {
    agent_collections: [],
    agent_balances: [],
    agentbalance_details: [],
    save_status: false,

};
export const getters = {
    AgentCollections: state => state.agent_collections.data,
    AgentBalances: state => state.agent_balances,
    AgentBalanceDetails: state => state.agentbalance_details.data,
    SaveStatus: state => state.save_status,
};

export const mutations = {
    SET_AGENT_COLLECTIONS(state, newValue) {
        state.agent_collections = newValue
    },

    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_AGENT_BALANCES(state, newValue) {
        state.agent_balances = newValue
    },
    SET_AGENTBALANCE_DETAILS(state, newValue) {
        state.agentbalance_details = newValue
    }

};

export const actions = {

    fetchAgentCollections({ commit }) {
        commit('SET_SAVE_STATUS', true)
        axios.get('agent_collections').then(ec_res => {
            commit('SET_AGENT_COLLECTIONS', ec_res.data)
            commit('SET_SAVE_STATUS', false)
        })
    },

    addAgentCollection({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_collections', payload).then(() => {
            dispatch('fetchAgentCollections');
            let message = { 'msg': `Agent Collection of amount ${payload.amount} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Agent Collection " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editAgentCollection({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`agent_collections/${payload.id}`, payload).then(() => {
            dispatch('fetchAgentCollections');
            let message = { 'msg': `Agent Collection of amount ${payload.amount} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Updating Agent Collection" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteAgentCollection({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_collections/${payload.id}`).then(() => {
            dispatch('fetchAgentCollections');
            let message = { 'msg': `Agent Collection of amount ${payload.amount} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Deleing Agent Collection" + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchAgentBalances({ commit }) {
        commit('SET_AGENT_BALANCES', true)
        axios.get('agentbalances').then(ec_res => {
            commit('SET_AGENT_BALANCES', ec_res.data)
        })
    },

    fetchAgentBalanceDetails({ commit }, id) {
        commit('SET_AGENTBALANCE_DETAILS', true)
        axios.get(`agentbalance_details/${id}`).then(ec_res => {
            commit('SET_AGENT_BALANCES', ec_res.data)
        })
    },

};